import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useDetailHandler from '../../hooks/useDetailHandler';
import AuctionHeaderProduct from './AuctionHeaderProduct';
import AuctionHeaderNumberOfLots from './energy/AuctionHeaderNumberOfLots';
import AuctionHeaderEnergyPerLot from './energy/AuctionHeaderEnergyPerLot';
import AuctionHeaderProgress from './AuctionHeaderProgress';
import AuctionHeaderPhase from './AuctionHeaderPhase';
import AuctionDetail from './AuctionDetail';
import { auctionPropertiesType, auctionType } from '../../types';
import './_styles_/AuctionRow.css';
import { getAllUIPhases } from '../../utils/AuctionPhase';
import { onActionKey } from '../../utils';
import AuctionHeaderQuantity from './security/AuctionHeaderQuantity';
import FlagIcon from '../FlagIcon';

export const getValueMapping = (t) => ({
    phase: getAllUIPhases().map((phase) => ({ from: phase.serverPhase, to: phase.translate(t) })),
});

AuctionRow.propTypes = {
    auction: auctionType.isRequired,
    auctionProps: auctionPropertiesType.isRequired,
    activeProductType: PropTypes.string,
};

AuctionRow.defaultProps = {
    activeProductType: null,
};

function AuctionRow(props) {
    const {
        auction,
        auctionProps,
        activeProductType,
    } = props;
    const { isDetailVisible, toggleDetail } = useDetailHandler(auction.id);
    return (
        <>
            <div className="rich-list-row auction-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="auction-header--main">
                    <div className="auction-header--arrow-mobile">
                        <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                    </div>
                    {auction.zone.flagCode && (
                        <>
                            <FlagIcon code={auction.zone.flagCode} size="2x" className="auction-header--flag-icon flag-icon--shadowed flag-icon--32" squared />
                            &nbsp;
                        </>
                    )}
                </div>
                <div className="auction-header--id">
                    {auction.id}
                </div>
                <div className="auction-header--name">
                    {auction.name}
                </div>
                <AuctionHeaderProduct product={auction.product} activeProductType={activeProductType} />
                {activeProductType === 'ENERGY' && (
                    <>
                        <AuctionHeaderNumberOfLots numberOfLots={auction.quantity} />
                        <AuctionHeaderEnergyPerLot energyPerLot={auction.energyPerLot} unit={auction.product.quantityUnit} />
                    </>
                )}
                {activeProductType === 'SECURITY' && (
                    <AuctionHeaderQuantity quantity={auction.quantity} />
                )}
                <AuctionHeaderProgress auction={auction} />
                <AuctionHeaderPhase phase={auction.phase} />
                <div className="auction-header--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <AuctionDetail
                    auctionId={auction.id}
                    auctionProps={auctionProps}
                />
            )}
        </>
    );
}

export default AuctionRow;
